import React, { useState } from 'react';
import {
  View, Text, TextInput, TouchableOpacity, StyleSheet,
  KeyboardAvoidingView, Platform, ScrollView, ActivityIndicator,
} from 'react-native';
import { useAuth } from '../context/AuthContext';

export default function LoginScreen({ navigation }) {
  const { login } = useAuth();
  const [email,    setEmail]    = useState('');
  const [senha,    setSenha]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [erro,     setErro]     = useState('');

  const handleLogin = async () => {
    setErro('');
    if (!email.trim() || !senha.trim()) {
      return setErro('Preencha e-mail e senha');
    }
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), senha);
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
      <ScrollView contentContainerStyle={styles.container} keyboardShouldPersistTaps="handled">
        {/* Logo */}
        <View style={styles.logoArea}>
          <Text style={styles.logo}>YBR</Text>
          <Text style={styles.logoSub}>Yellow Brick Road</Text>
        </View>

        {/* Card de login */}
        <View style={styles.card}>
          <Text style={styles.cardTitle}>Entrar</Text>

          <Text style={styles.label}>E-mail</Text>
          <TextInput
            style={styles.input}
            placeholder="seu@email.com"
            placeholderTextColor="#aaa"
            keyboardType="email-address"
            autoCapitalize="none"
            value={email}
            onChangeText={setEmail}
          />

          <Text style={styles.label}>Senha</Text>
          <View style={styles.inputRow}>
            <TextInput
              style={[styles.input, { flex: 1, marginBottom: 0 }]}
              placeholder="••••••••"
              placeholderTextColor="#aaa"
              secureTextEntry={!showPass}
              value={senha}
              onChangeText={setSenha}
            />
            <TouchableOpacity onPress={() => setShowPass(!showPass)} style={styles.eyeBtn}>
              <Text style={{ fontSize: 20 }}>{showPass ? '🙈' : '👁️'}</Text>
            </TouchableOpacity>
          </View>

          {!!erro && <Text style={styles.erro}>{erro}</Text>}

          <TouchableOpacity
            style={[styles.btnPrimary, loading && { opacity: 0.7 }]}
            onPress={handleLogin}
            disabled={loading}
          >
            {loading
              ? <ActivityIndicator color="#1a1a1a" />
              : <Text style={styles.btnPrimaryText}>Entrar</Text>
            }
          </TouchableOpacity>

          <TouchableOpacity onPress={() => navigation.navigate('Register')}>
            <Text style={styles.linkText}>Não tem conta? <Text style={styles.linkBold}>Cadastre-se</Text></Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container:   { flexGrow: 1, backgroundColor: '#F5C518', justifyContent: 'center', padding: 24 },
  logoArea:    { alignItems: 'center', marginBottom: 36 },
  logo:        { fontSize: 52, fontWeight: '900', color: '#1a1a1a', letterSpacing: 4 },
  logoSub:     { fontSize: 14, color: '#444', marginTop: 4, letterSpacing: 2 },
  card:        { backgroundColor: '#fff', borderRadius: 20, padding: 24, shadowColor: '#000', shadowOpacity: 0.1, shadowRadius: 12, elevation: 6 },
  cardTitle:   { fontSize: 24, fontWeight: 'bold', color: '#1a1a1a', marginBottom: 20 },
  label:       { fontSize: 13, fontWeight: '600', color: '#555', marginBottom: 6, marginTop: 12 },
  input:       { backgroundColor: '#f5f5f5', borderRadius: 10, paddingHorizontal: 14, paddingVertical: 12, fontSize: 15, color: '#1a1a1a', marginBottom: 4 },
  inputRow:    { flexDirection: 'row', alignItems: 'center', marginBottom: 4 },
  eyeBtn:      { padding: 10, marginLeft: 6 },
  btnPrimary:  { backgroundColor: '#F5C518', borderRadius: 12, paddingVertical: 14, alignItems: 'center', marginTop: 20, marginBottom: 12 },
  btnPrimaryText: { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a' },
  linkText:    { textAlign: 'center', color: '#666', fontSize: 14 },
  linkBold:    { fontWeight: 'bold', color: '#1a1a1a' },
  erro:        { backgroundColor: '#fdecea', color: '#c0392b', borderRadius: 8, padding: 10, marginTop: 12, fontSize: 14, textAlign: 'center' },
});
